import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { registerBoost } from '../subscription.service';
import { subscriptionsKeys } from '../subscriptions.keys';
/**
 * Mutation hook for registering a boost for quest or sprint
 */
export function useRegisterBoost() {
    const domain = getSubdomain();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ type, questId }) => registerBoost(domain, type, questId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: subscriptionsKeys.currentBoost(domain) });
        },
    });
}
